import { API_ENDPOINTS } from "../constants/apiConfig";
import { makeRequest } from "../middleware/axiosMiddleware";

export const wemAPIService = {
    getWemList,
    getFiltersData,
    postRequestQuote,
};


async function getWemList(data: any) {
    const apiPath = API_ENDPOINTS.ENQUIRY + "/enquiries/workshop/getEquipment-Material"
    const options = {
        path: apiPath,
        customHeaders: {},
        method: "POST",
        bodyObj: data,
        formdata: true
    };
    return await makeRequest(options);
}

async function getFiltersData() {
    const apiPath = API_ENDPOINTS.ENQUIRY + "/enquiries/workshop/getEquipment-Category"
    const options = {
        path: apiPath,
        customHeaders: {},
        method: "GET",
        formdata: true
    };
    return await makeRequest(options);
}

async function postRequestQuote(data: any) {
    const apiPath = API_ENDPOINTS.ENQUIRY + "/enquiries/workshop/wemRequestQuote"
    const options = {
        path: apiPath,
        method: "POST",
        bodyObj: data,
        customHeaders: {},
        formdata: true
    };
    return await makeRequest(options);
}

